import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import InfoWithTooltip from './InfoWithTooltip';
import { useState, useMemo } from 'react';

export interface CourseProps {
  name: string;
  code?: string;
  shortening?: string;
  credits?: number | string;
  color?: string;
  examGrade?: string | null;
  finalGrade?: string | null;
  replaceCredits?: string | null;
  toolTip?: string;
  toolTipId?: string;
  onClick?: () => void;
}

export default function Course({
  name,
  code,
  shortening,
  credits,
  color,
  examGrade,
  finalGrade,
  replaceCredits,
  toolTip,
  toolTipId,
  onClick,
}: CourseProps) {
  const prefix = 'progressionBySemester';
  const { t } = useTranslation();

  const [hovered, setHovered] = useState(false);
  const { onMouseEnter, onMouseLeave } = useMemo(() => {
    if (!onClick) {
      return {
        onMouseEnter: undefined,
        onMouseLeave: undefined,
      };
    }
    return {
      onMouseEnter() {
        setHovered(true);
      },
      onMouseLeave() {
        setHovered(false);
      },
    };
  }, [onClick]);

  return (
    <div
      className={clsx('border-gray-100')}
      style={{
        borderColor: '#f4f4f4',
        width: '100px',
        maxWidth: '120px',
        minHeight: '100px',
        borderWidth: '1px',
        borderStyle: 'solid',
        padding: '5px 10px',
        borderRadius: '4px',
        backgroundColor: color,
        ...(hovered
          ? {
              boxShadow: '0px 6px 20px #0056A33B',
            }
          : {}),
        ...(onClick
          ? {
              cursor: 'pointer',
            }
          : {
              cursor: 'default',
            }),
      }}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div
        className="course-name text-color-dark"
        title={name}
        style={{
          height: '45px',
          overflow: 'hidden',
          display: '-webkit-box',
          boxOrient: 'vertical',
          lineClamp: 3,
          fontSize: '12px',
          lineHeight: '15px',
          marginBottom: '10px',
        }}
      >
        {name}
      </div>

      {shortening && <div className="course-detail pb-0">{shortening}</div>}
      <div className="fs-10 course-detail d-flex justify-content-between align-items-end">
        {replaceCredits ? (
          replaceCredits
        ) : (
          <>
            {t(`${prefix}.credits`)}: {credits}
          </>
        )}
        {toolTip && (
          <InfoWithTooltip
            show
            tooltipId={toolTipId ?? code ?? name}
            tooltipText={toolTip}
          />
        )}
      </div>
    </div>
  );
}
